/*
 * dual-media-banner.js
 * Initialises the desktop "one long banner" slider added to the
 * dual-media-slideshow section. Runs alongside the existing
 * dual-media-slideshow.js (which only knows about the split layout).
 */
(function () {
  var ATTR = 'data-swiper-desktop';
  var tries = 0;

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[' + ATTR + ']');
    if (!nodes.length) return true;

    if (typeof Swiper === 'undefined') return false;

    nodes.forEach(function (el) {
      if (el.swiper) return;
      try {
        el.swiper = new Swiper(el, JSON.parse(el.getAttribute(ATTR)));
      } catch (err) {
        console.error('[dual-media-banner] could not start slider', err);
      }
    });
    return true;
  }

  function boot(root) {
    tries = 0;
    (function attempt() {
      if (initAll(root)) return;
      if (tries++ > 60) return;
      setTimeout(attempt, 100);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var nodes = event.target.querySelectorAll('[' + ATTR + ']');
    nodes.forEach(function (el) {
      if (el.swiper && el.swiper.destroy) el.swiper.destroy();
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target;
    if (!slide || !slide.classList || !slide.classList.contains('dual-media-banner-slide')) return;
    var wrapper = slide.closest('[' + ATTR + ']');
    if (wrapper && wrapper.swiper) {
      wrapper.swiper.slideTo(parseInt(slide.dataset.swiperSlideIndex, 10) || 0);
    }
  });
})();
